import * as React from 'react';

import PropTypes from 'prop-types';

import {RectangleView} from './rectangle-view';

const MAX_BAR_WIDTH = 160;

export class FunnelCloseStatusBar extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,

        // Link to the leads report
        htmlUrl: PropTypes.string.isRequired,

        // The percentage of leads closing here, out of total leads in stage
        percent: PropTypes.number.isRequired,

        // The max size value of all bars (for relative sizing)
        maxCount: PropTypes.number.isRequired,
        onPress: PropTypes.func,
        children: PropTypes.node,
        isBlank: PropTypes.bool.isRequired,
    };

    render() {
        const maxSize = this.props.isBlank ? 100 : this.props.maxCount;
        const count = this.props.isBlank ? 5 : Math.min(this.props.percent, 100); // Ensure not > 100
        const tooltipTitle = `Leads ${this.props.name.toLowerCase()} in this stage during the specified date range`;

        return (
            <div className='ui-funnel-report__close-container'>
                <div
                    className={`ui-funnel-report__close-container--${this.props.name.toLowerCase()}`}
                >
                    <a
                        href={this.props.htmlUrl && count > 0 ? this.props.htmlUrl : undefined}
                        className='ui-funnel-report__close__bar-container ui-funnel-section-tooltip-status-bar'
                        data-title={tooltipTitle}
                    >
                        <RectangleView
                            size={count}
                            maxSize={maxSize}
                            maxPixelWidth={MAX_BAR_WIDTH}
                            minPixelWidth={0}
                        />
                        <div
                            className='ui-funnel-report__close__bar-background'
                            style={this.getBackgroundStyle()}
                        />
                    </a>
                    <a
                        href={this.props.htmlUrl && count > 0 ? this.props.htmlUrl : undefined}
                        className={`ui-funnel-report__close__text-container ${
                            count === 0 ? 'ui-funnel-report__close__text-container--empty' : ''
                        }`}
                    >
                        <div className='ui-funnel-report__close__percent-container'>
                            <span className='ui-funnel-report__close__percent-text'>
                                {this.props.isBlank ? 0 : this.props.percent}%
                            </span>
                        </div>
                        <div
                            onClick={this.props.onPress}
                            className='ui-funnel-report__close__count-name-container'
                        >
                            <div className='ui-funnel-report__close__child-container'>
                                {this.props.children}
                            </div>
                            <span className='ui-funnel-report__close__name-text'>
                                {this.props.name}
                            </span>
                        </div>
                    </a>
                </div>
            </div>
        );
    }

    getBackgroundStyle = () => {
        const percentFilled = this.props.isBlank ? 5 : this.props.percent;

        return {
            width: ((100 - Math.min(percentFilled, 100)) / 100) * MAX_BAR_WIDTH,
        };
    };
}
